// Logging constants
export const LOG = true;
export const ERR = true;

export const REDUX_LOG = true;

// Debugging Constants
export const RANDOMIZE_PILLARS = false;

// Fuckery
export const LOADING_TIME = 2000;
